<script>
 import { HtmlWhitelistedSanitizer } from './HtmlSanitizer.js'
 import { getFormats } from './utils.js';
 import { onMount } from 'svelte';
 export let book;
 export let bookm;
 import { lasthash } from './store.js';
 import { createEventDispatcher } from 'svelte';
 import { download_svg } from './svgs.js';

 let lochash = [];

 const dispatch = createEventDispatcher();
 const unsubscribe = lasthash.subscribe(value => {
     lochash = JSON.parse(value);
 });

 function onKeyDown(e) {
     if (e.key === "Escape") {
         toggle(e);
     } else if (e.key === "ArrowRight" || e.target.id === "next") {
         dispatch("nextModal", book._id)
     } else if (e.key === "ArrowLeft" || e.target.id === "prev") {
         dispatch("prevModal", book._id)
     }
 }

 function sanitizeAbstract(a) {
     var parser = new HtmlWhitelistedSanitizer(true);
     var _ = parser.sanitizeString(a.replace("**",""));
     return _
 }

 function toggle(e) {
     lochash[0] = true;
     lasthash.set(JSON.stringify(lochash))
     window.location.hash = lochash[1];
     bookm = false;
 }
</script>

<style>
 .modal {
     @apply h-full w-full fixed z-50 overflow-auto flex;
     background-color: rgba(0,0,0,0.7);
 }

 .cover {
     @apply bg-white border-white border-2 border-t-8 border-l-8;
     min-height: 4em;
     background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2063.5%2084.7%22%20height%3D%22320%22%20width%3D%22240%22%3E%3Cpath%20d%3D%22M5.292%205.292h52.917v74.083H5.292z%22%20fill%3D%22%23e0e0e0%22%20paint-order%3D%22stroke%20fill%20markers%22%2F%3E%3Cpath%20d%3D%22M10.6%2010.6h42.3v63.5H10.6z%22%20fill%3D%22%23c0c0c0%22%20paint-order%3D%22stroke%20fill%20markers%22%2F%3E%3Cpath%20d%3D%22M15.8%2015.8h31.8v53H15.8z%22%20fill%3D%22%23a0a0a0%22%20paint-order%3D%22stroke%20fill%20markers%22%2F%3E%3C%2Fsvg%3E");
     background-repeat: no-repeat;
     background-size: cover;
 }
</style>

<svelte:window on:keydown={onKeyDown} />
<div on:click|self={toggle} class="modal px-4 monocle:px-0 phone:px-0">
    <div class="pt-6 w-full max-w-4xl m-auto flex-col flex monocle:text-xs phone:text-xs">
        <div class="inset-x-0.top-0 p-6 monocle:px-4 phone:px-4 bg-motw-red text-white font-extrabold text-xl monocle:text-sm phone:text-sm"><span title="[ESC]" on:click={toggle} class="cursor-pointer monocle:text-2xl phone:text-2xl monocle:pr-2 phone:pr-2 float-right font-extrabold text-white opacity-50">&nbsp;x</span> “{book.title}” by {#each book.authors as author, i}{#if i+1 < 4 }{author}{/if}{#if i+1 !== book.authors.length && i+1 < 4 },&nbsp;{:else if i+1 === 4 } et al.{/if}{/each}</div>
        <div class="bg-white phablet:p-6">
            {#if book.cover_url}
                <div class="cover phablet:w-1/2 phablet:float-right monocle:pr-3 phone:pr-3">
                    <img class="text-white object-cover w-full" src={book.library_url+book.cover_url} alt="" />
                    {#if book.formats != undefined && book.formats.length != 0 }
                        <div class=".inset-x-0.bottom-0 bg-black"><span class="pl-2 text-white text-base font-bold">Download:</span>
                            {#each getFormats(book) as format}
                                <a class="hover:underline inline-block font-bold italic text-xl pr-3 py-1 bg-black text-white" href="{format.url}" title="{format.size}"><img class="w-4 inline-block" alt="dl" src="{download_svg}">{format.title.replace(",", "")}</a>
                            {/each}
                        </div>
                    {:else}
                        <div class=".inset-x-0.bottom-0 bg-black text-black">.</div>
                    {/if}
                </div>
            {/if}
            <div class="pt-4 monocle:px-2 phone:px-2">
                <span class="font-bold">Title: </span>{book.title}
            </div>
            {#if book.authors}
                <div class="pt-3 monocle:px-2 phone:px-2">
                    <span class="font-bold">Authors: </span>
                    {#each book.authors as author, i}
                        <a title="search in authors" on:click|self={toggle} href="#/search/authors/{author}" class="hover:underline">{author}</a>{#if i+1 !== book.authors.length},&nbsp;{/if}
                    {/each}
                </div>
            {/if}
            {#if book.publisher}
                <div class="pt-3 monocle:px-2 phone:px-2">
                    <span class="font-bold">Publisher:</span>
                    <a title="search in publishers" on:click|self={toggle} href="#/search/publisher/{book.publisher}" class="hover:underline">{book.publisher}</a>
                </div>
            {/if}
            {#if book.series}
                <div class="pt-3 monocle:px-2 phone:px-2">
                    <span class="font-bold">Series:</span>
                    <a title="search in series" on:click|self={toggle} href="#/search/series/{book.series}" class="hover:underline">{book.series}</a>
                </div>
            {/if}
            {#if book.year}
                <div class="pt-3 monocle:px-2 phone:px-2">
                    <span class="font-bold">Year: </span>{book.year}
                </div>
            {/if}
            {#if book.abstract}
                <div class="pt-3 monocle:px-2 phone:px-2">
                    {@html sanitizeAbstract(book.abstract)}
                </div>
            {/if}
        </div>
        {#if book.tags && book.tags.length > 0 }
            <div class="p-6 monocle:px-2 phone:px-2 monocle:text-xs phone:text-xs text-sm italic bg-white">
                <span class="font-bold">Tags: </span>
                {#each book.tags as tag, i}
                    <a title="search in tags" on:click|self={toggle} href="#/search/tags/{tag}" class="hover:underline">{tag}</a>{#if i+1 !== book.tags.length},&nbsp;{/if}
                {/each}
            </div>
        {/if}
        <div class="inset-x-0.bottom-0 items-baseline bg-motw-red text-white font-bold p-6 monocle:px-2 phone:px-2 flex justify-between items-center">
            <a class="hover:underline inline-flex" href="#/search/librarian/{book.librarian}">catalogued by {book.librarian}</a>
            <div class="text-motw-red text-center select-none">.</div>
            <div class="font-extrabold text-white monocle:text-xl phone:text-xl monocle:pr-2 phone:pr-2">
                <span title="[←]" id="prev" on:click={onKeyDown} class="hover:underline cursor-pointer">&lt;&lt</span>&nbsp;<span title="[→]" id="next" on:click={onKeyDown} class="hover:underline cursor-pointer">&gt;&gt</span>
            </div>
        </div>
    </div>
</div>
